module.exports = __webpack_public_path__ + "static/media/fruit-cherry.d7106c59.png";